import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import GlobalLoadingUi from './loadingUi/GlobalLoadingUi';
import { AuthCheck } from "./utils/Auth";
import AgentDetails from "./views/Agents/AgentDetails";
import Agents from "./views/Agents/Agents";
import Dashboard from "./views/Dashboard/Dashboard";
import DeveloperSection from "./views/DeveloperSection/DeveloperSection";
import BusinessCardAnalytics from "./views/DigitalCard/BusinessCardAnalytics";
import CreateQrForCard from "./views/DigitalCard/Components/CreateQrForCard";
import DigitalCard from "./views/DigitalCard/DigitalCard";
import DigitalCardBuilder from "./views/DigitalCard/DigitalCardBuilder";
import GoogleAnalytics from "./views/GoogleAnalytics/GoogleAnalytics";
import Influencer from "./views/Influencer/Influencer";
import InfluencerProfile from "./views/Influencer/InfluencerProfile";
import Invitation from "./views/Invitation/Invitation";
import LinkDetails from "./views/Links/LinkDetails";
import Links from "./views/Links/Links";
import Login from './views/Login/Login';
import MetaAds from "./views/MetaAds/MetaAds";
import AllPages from "./views/MicroPages/AllPages";
import CreatePageTabs from "./views/MicroPages/CreatePageTabs";
import PageDetails from "./views/MicroPages/PageDetails";
import NotFound from './views/NotFound/NotFound';
import CustomizeQR from "./views/QRCode/CustomizeQR";
import QRCodeList from "./views/QRCode/QRCodeList";
import QrDetails from "./views/QRCode/QrDetails";
import RewardAndRefer from "./views/Rewards/RewardAndRefer";
import Settings from "./views/Settings/Settings";
import SplashScreen from './views/SplashScreen/SplashScreen';
import Support from "./views/Support/Support";
import Promotions from "./views/Promotions/Promotions";
import PromotionDetails from "./views/Promotions/PromotionDetails";
import LiveChat from "./views/LiveChat/LiveChat";
import CallList2 from "./views/LiveChat/SubViews/CallList2";
import PricingPlan from "./views/Pricing/PricingPlan";
import { PROFILE } from "./statics/localStorage";
import { checkDomain } from "./utils/domainCheck.util";
import OrganizationForm from "./views/Login/OrganizationForm";

function App() {
  const [isMob, setIsMob] = useState(window.innerWidth < 992 ? true : false);

  const profileData = PROFILE();

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsMob(true)
    } else {
      setIsMob(false)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Toaster visibleToasts={3} duration={2000} theme='light' richColors position='bottom-center' />
      <GlobalLoadingUi />
      {checkDomain() === "chat" && <CallList2 />}

      {/* {!isMob ? */}
      <Routes>
        <Route element={<AuthCheck />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/links-list" element={<Links />} />
          <Route path="/link-details" element={<LinkDetails />} />

          <Route path="/qr-codes" element={<QRCodeList />} />
          <Route path="/qr-codes-customize" element={<CustomizeQR />} />
          <Route path="/qr-details" element={<QrDetails />} />

          <Route path="/pages" element={<AllPages />} />
          <Route path="/create-page/:pageId?" element={<CreatePageTabs />} />
          <Route path="/page-details" element={<PageDetails />} />

          <Route path="/business-cards" element={<DigitalCard />} />
          <Route path="/create-business-cards/:cardId?" element={<DigitalCardBuilder />} />
          <Route path="/business-card-details" element={<BusinessCardAnalytics />} />
          <Route path="/create-business-card-qr" element={<CreateQrForCard />} />

          <Route path="/meta-ads" element={<MetaAds />} />

          <Route path="/google-analytics" element={<GoogleAnalytics />} />

          <Route path="/agents" element={<Agents />} />
          <Route path="/agent-detail/:agentId?" element={<AgentDetails />} />

          <Route path="/influencers" element={<Influencer />} />
          <Route path="/influencer/:influencerId?" element={<InfluencerProfile />} />

          <Route path="/promotions" element={<Promotions />} />
          <Route path="/promotion-details" element={<PromotionDetails />} />

          <Route path="/rewards-&-refer" element={<RewardAndRefer />} />

          <Route path="/support" element={<Support />} />

          <Route path="/developer-section" element={<DeveloperSection />} />

          <Route path="/live-chat" element={(typeof profileData?.currentPlanId === "undefined" || profileData?.currentPlanId === null) ? <PricingPlan /> : <LiveChat />} />

          <Route path="/settings" element={<Settings />} />

          <Route path="/pricing-plan" element={<PricingPlan />} />

        </Route>


        <Route path="/" element={<SplashScreen />} />
        <Route path="/invitation" element={<Invitation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/organization-form" element={<OrganizationForm />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* : <MobileView /> */}
      {/* } */}
    </>
  );
}

export default App;
